<template>
  <div v-if="loading" class="flex h-full justify-center items-center">
    <loading-spinner diameter="64px" />
  </div>

  <alert-badge
    v-else-if="error.title"
    isDanger
    :title="error.title"
    :body="error.body"
    @dismissed="
      () => {
        error.title = ''
        error.body = ''
      }
    "
  />

  <attribute-form
    v-else
    :initAttribute="initAttribute"
    :successMsg="$t('actions.saveChangesSuccess')"
    :submitAction="update"
  />
</template>

<script lang="ts">
import { defineComponent, onBeforeMount, ref } from 'vue'

import { useHTTP } from '@/plugins/http'

import Attribute from '@/models/inventory/Attribute'

// components
import LoadingSpinner from '@/components/LoadingSpinner.vue'
import AttributeForm from '@/views/inventory/attributes/AttributeForm.vue'
import AlertBadge from '@/components/AlertBadge.vue'
import { useRoute } from 'vue-router'

export default defineComponent({
  name: 'attribute',
  components: {
    LoadingSpinner,
    AttributeForm,
    AlertBadge
  },

  setup() {
    const initAttribute = ref(new Attribute())
    const http = useHTTP()
    const loading = ref(true)
    const error = ref({ title: '', body: '' })

    const route = useRoute()

    onBeforeMount(async () => {
      const url = `${Attribute.ENDPOINT}/${route.params.id}`

      try {
        const resp = await http.get<Attribute>(url)
        initAttribute.value = Attribute.from(resp)
      } catch (errorResp) {
        error.value.title = errorResp.title
        error.value.body = errorResp.body
      }

      loading.value = false
    })

    const update = async (attribute: Attribute) => {
      try {
        const url = `${Attribute.ENDPOINT}/${attribute.id}`
        const resp = await http.put<Attribute>(url, attribute)
        initAttribute.value = Attribute.from(resp)
      } catch (error) {
        return error
      }
    }

    return {
      initAttribute,
      loading,
      update,
      error
    }
  }
})
</script>
